import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { formatPrice } from '../../utils/currency';
interface Props {
  visible: boolean;
  image: string;
  name: string;
  options: string[];
  price: number;
  compareAt?: number;
  ctaLabel: string;
  onAdd: () => void;
}
export function StickyBuyBar({
  visible,
  image,
  name,
  options,
  price,
  compareAt,
  ctaLabel,
  onAdd
}: Props) {
  return <AnimatePresence data-id="element-436" data-mp="2uutefwy65rqr">
      {visible && <motion.div initial={{
      y: '100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '100%'
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-30 border-t border-line bg-white/95 backdrop-blur" data-id="element-437" data-mp="2utibu0ggmq18">
          <div className="mx-auto flex max-w-7xl items-center gap-4 px-4 py-3 sm:px-6 lg:px-8" data-id="element-438" data-mp="2zn4q1x29v1z5">
            <img src={image} alt="" className="hidden h-12 w-12 rounded-lg bg-surface object-cover sm:block" data-id="element-439" data-mp="3dmdw43wrkfpe" />
            <div className="min-w-0 flex-1" data-id="element-440" data-mp="38kwx6dxub3bg">
              <p className="truncate text-sm font-semibold text-ink" data-id="element-441" data-mp="tl3cj9g7sag8">{name}</p>
              <p className="hidden truncate text-xs text-muted sm:block" data-id="element-442" data-mp="yj4vludn49rp">{options.join(' · ') || 'In stock · ships tomorrow'}</p>
            </div>
            <div className="text-right" data-id="element-443" data-mp="13hoflp8obbhf">
              <p className="text-lg font-bold leading-tight tracking-tight text-ink" data-id="element-444" data-mp="17k316h3q8pce">{formatPrice(price)}</p>
              {compareAt && <p className="text-xs text-muted line-through" data-id="element-445" data-mp="1cjo2uzaa7bst">{formatPrice(compareAt)}</p>}
            </div>
            <button type="button" onClick={onAdd} className="h-11 shrink-0 whitespace-nowrap rounded-lg bg-volt px-5 text-sm font-bold text-ink transition-colors duration-150 hover:bg-volt-hover" data-id="element-446" data-mp="1hhh6plo43tpx">
              {ctaLabel}
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}